import {ResourceTaskTime} from "./ResourceTaskTime";
import {Resource} from "./Resource";
import {Task} from "app/entities/Task";

export class JobCalendar {
  PlacedEvents : ResourceTaskTime[];
  Resources : Resource[];
  //ExternalTasks : Task[];

}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/entities/JobCalendar.ts